import { type ContractType } from '@/common/types/contract';

import planePng from '/img/contract/plane.png';
import planeWebp from '/img/contract/plane.webp';
import shipPng from '/img/contract/ship.png';
import shipWebp from '/img/contract/ship.webp';
import truckPng from '/img/contract/truck.png';
import truckWebp from '/img/contract/truck.webp';

const images: Partial<
  Record<ContractType, { img: string; webp: string; className?: string }>
> = {
  GoldenPlus: {
    img: truckPng,
    webp: truckWebp,
    className: 'w-[238px] aspect-[360/320]',
  },
  BlitzPlus: {
    img: planePng,
    webp: planeWebp,
    className: 'w-[340px] aspect-[340/170]',
  },
  GrandPlus: {
    img: shipPng,
    webp: shipWebp,
    className: 'w-[272px] aspect-[543/396]',
  },
};

export { images };
